import { render, staticRenderFns } from "./Halbkreis.vue?vue&type=template&id=2fb3dcea&"
import script from "./Halbkreis.vue?vue&type=script&lang=js&"
export * from "./Halbkreis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports